/*
 * @Author: Merlin
 * @Date: 2025-06-20 15:11:00
 * @LastEditors: Merlin
 * @LastEditTime: 2025-08-21 15:28:08
 * @Description: redPacketMines.**** 
 */

// ↓ 规则集中区 
const oRules = {
    rule01Title: {
        en: '1. Basic Rules',
        cn: '1.基础规则',
    },
    rule02Title: {
        en: '2. Odds Description',
        cn: '2.赔率说明',
    },
    rule03Title: {
        en: '3. Settlement Rules',
        cn: '3.结算规则',
    },
    // ================================================= 
    rule01_1: {
        en: 'Players can choose the gold amount of red packet, amount of packets, mines number and issue the red packets. Other players may grab the red packets.',
        cn: '发红包玩家设定好红包的金额、包数、雷号后发出红包，其他玩家可以抢这个红包。',
    },
    rule01_2: {
        en: 'Players who grab the issued red packets without stepping on mines will be rewarded with random amount of money.',
        cn: '未踩雷的玩家可以获得抢到的随机金额。',
    },
    rule01_3: {
        en: 'If player grabs a red packet with its last number of money amount in it is same as the mines number, player will step on mines and pay out to the player who issued the corresponding red packet.',
        cn: '如果抢红包玩家抢到金额的尾数与雷号相同，则中雷，要向发红包玩家进行赔付。',
    },
    rule02_column01A: {
        en: 'Number of Packets',
        cn: '包数',
    },
    rule02_column01B: {
        en: 'Odds',
        cn: '赔率',
    },
    // ============================================== 
    rule03_1: {
        en: 'Commission rate is {taxRate}%.',
        cn: '抽水率为 {taxRate}%。',
    },
    rule03_2: {
        en: 'Players who grab red packets without stepping on mine will be rewarded with money amount after deducting commission.',
        cn: '抢包未中雷，则抽水后为实际收益金额。',
    },
    rule03_3: {
        en: 'Players who step on mines after grabbing red packets will have to pay out according to the odds correspond to its number of red packets issued.',
        cn: '抢包中雷，则按对应赔率赔付。',
    },
    rule03_4: {
        en: 'Players who issue red packets will be rewarded accordingly if other players step on mines, and the leftover red packets will be refunded. Profit will be accounted after deducting commission.',
        cn: '发出的包如有人中雷，则获得对应赔付，未抢完的会退还，如有盈利则盈利部分抽水。',
    },
    rule03_5: {
        en: 'The validity period of the red packets is {sec} seconds. Any portion that has not been grabbed after the deadline will be returned to the sender.',
        cn: '红包有效期为 {sec} 秒，超时未被抢完的部分会被退回发包人。',
    },
};


// ↓ 按钮集中区 
const oBtn = {
    'Grab': {
        en: 'Grab', // 抢红包
        cn: '抢',
    },
    'quickJoin': {
        en: 'Quick Join', 
        cn: '快速开始',
    },
    ChangeRoom: {
        en: 'Change Room',
        cn: '换房',
    },
    Random: {
        en: 'Random',
        cn: '随机',
    },
    'sendRedPacket': {
        en: 'Send red packet', 
        cn: '发红包',
    },
    'autoSend': {
        en: 'Auto send', 
        cn: '续发',
    },
    'autoUnpack': {
        en: 'auto unpack', 
        cn: '自动抢',
    },
    'random': {
        en: 'Random', 
        cn: '随机',
    },
    'noDetail': { // 按钮提示 
        en: 'No one grab it, no details available', 
        cn: '无人抢包，暂无详情', 
    },
};

// ↓房间列表
const oHall = {
    SelectRoom: {
        en: 'Select Room',
        cn: '选择房间',
    },
    hall01:{
        en: 'Novice',
        cn: '体验厅',
    },
    hall02:{
        en: 'Leisure',
        cn: '娱乐厅',
    },
    hall03:{
        en: 'Flagship',
        cn: '旗舰厅',
    },
    hall04:{
        en: 'Royal',
        cn: '富豪厅',
    },
    hall05:{
        en: 'Supreme',
        cn: '至尊厅',
    },
};


// 历史记录详情相关 
const oHistoryAbout = {
    'historyDetails': {
        en: 'Details',
        cn: '抢红包详情',
    },
    'RecordsGrabbed': {
        en: 'Records grabbed',
        cn: '抢红包记录',
    },
    'SentRecords': { 
        en: 'Sent records',
        cn: '发红包记录',
    },
    'HongbaoGot': {
        en: 'Hongbao Got',
        cn: '抢到红包数',
    },
    'HongbaoSent': {
        en: 'Hongbao Sent',
        cn: '发出红包数',
    },
    'BombQty': { 
        en: 'Bomb',
        cn: '中雷数',
    },
    'AsMuch20Records': { 
        en: 'View up to {rows} records',
        cn: '最多查看 {rows} 条记录',
    },
    'sender': { 
        en: 'User',
        cn: '发红包玩家',
    },
    'AmountReceived': { 
        en: 'Amount',
        cn: '抢到金额', 
    },
    'Profit': { 
        en: 'After tax income',
        cn: '税后收益', 
    },
    'Profit1': { 
        en: 'Revenue of the contractor',
        cn: '发包人收益', 
    },
    'PacketAmount': { 
        en: 'Packet amount',
        cn: '红包面额', 
    },
    'packetLeft': { 
        en: 'Red packet left',
        cn: '剩余包数', 
    },
    'packetSender': { 
        en: 'Packet sender',
        cn: '发包玩家', 
    },
    'SentAt': { 
        en: 'Sent at',
        cn: '发包时间', 
    },
    'PacketSenderInfo': {
        en: 'Packet sending information',
        cn: '发包信息', 
    },
    'PacketGraberInfo': {
        en: 'Packet grabing information', 
        cn: '抢包信息', 
    },
};


const oPlayerInfo = {
    yourself: {
        en: 'yourself',
        cn: '您',
    },
    actionEvade: {
        en: '{user} evaded mine {times} times in a row, so great!',  
        cn: '{user} 连续避雷 {times} 次, 真是太厉害了！', 
    },
    actionSend: {
        en: '{user} sent [{qty} * {type} persons packet(s)]',
        cn: '{user} 派发 【{qty}个 x {type}人红包】',
    },
    actionCollect: {
        en: '{collecter} collected {amount} from the packet sent by {sender}',
        cn: '{collecter} 在 {sender} 的红包中抢到了 {amount}',
    },
};

// 一些弹出的提示信息 
const oToast = {
    lowBalance: {
        en: 'Insufficient balance, unable to enter this hall',
        cn: '余额不足，无法进入此厅',
    },
    CannotCollectYourOwn: {
        en: `Cannot collect your own packet`, 
        cn: '不能抢自己的红包',
    },
    CollectionTooOften: {
        en: `The operation is too fast, please wait a moment`, 
        cn: '操作过快，请稍等一下',
    },
    NoRedPacket: {
        en: `There are no red packets available for the current type. Please try other types`, 
        cn: '当前类型无可抢红包，请尝试其它类型红包',
    },
    congratulation: {
        en: 'You won',
        cn: '◆ 恭喜 ◆',
    },
    multiKill: {
        en: 'Multi kill {num}',
        cn: '{num} 连杀',
    },
    chooseNumber: {
        en: 'Please choose a mine number',
        cn: '请选择一个雷号',
    },
    enteredRoom: {
        en: 'Now you entered：{room}',
        cn: '您来到了：{room}',
    },
    switchConfirm: {
        en: 'After confirmation, the “automatic bag grabbing” function will be turned off and redirected',
        cn: '确定后将关闭“自动抢包”功能，并跳转',
    },
    autoModeIsStoping: {
        en: 'Insufficient balance, automatic bag grabbing function has been disabled',
        cn: '余额不足，自动抢包功能已关闭',
    },
    autoModeUnusable: {
        en: 'Insufficient balance, unable to activate automatic package grabbing function',
        cn: '余额不足，无法启动自动抢包功能',
    },
    unableToCollectThis: {
        en: 'Insufficient balance, unable to grab [{num} persons packet]',
        cn: '余额不足，无法抢【{num}人红包】',
    },
    failedPleaseTryAgain: {
        en: 'The operation was unsuccessful, please try again', 
        cn: '操作未成功，请重试',
    },
};

// 玩家列表窗口
const oPlayerListDialog = {
    PlayerList: {
        en: 'Player List',
        cn: '玩家列表',
    },
    Username: {
        en: 'Users',
        cn: '玩家', 
    },
    playerBalance: {
        en: 'player balance',
        cn: '用户余额', 
    },
};

// ▼ 最终结果 
export const oRedPacketMines = {
    ...oRules,
    ...oBtn, 
    ...oHall, 
    ...oPlayerInfo, 
    ...oHistoryAbout, 
    ...oPlayerListDialog, 
    ...oToast,
    'packets': {
        en: '{val} packets',
        cn: '{val}包',
    },
    'packetsShortened': {
        en: '{val} Pac.',
        cn: '{val}包',
    },
    'packetsRest': {
        en: 'Behind:●packets',
        cn: '后面还有●个红包',
    },
    'packetQty2Send': {
        en: 'Packet quantity to send', 
        cn: '发包数量',
    },
    'BombNumber': {
        en: 'Bomb No.', 
        cn: '雷号',
    },
    'Odds': {
        en: 'Odds', 
        cn: '赔率',
    },
    'PleaseSetRules': {
        en: 'Please set the rules for auto collecting', 
        cn: '请设定自动抢包规则',
    },
    'atLeastOne': {
        en: 'Select at least one type of red envelope', 
        cn: '最少选中一种类型红包',
    },
    'willStart': {
        en: 'Once confirmed, it will start immediately', 
        cn: '确认后将立即开始',
    },
    access: {
        en: 'Access',
        cn: '准入',
    },
    ante: {
        en: 'Ante',
        cn: '底注',
    },
    myPacket: {
        en: 'My packet',
        cn: '我的红包',
    },
    'setBombNumber': {
        en: 'Please set bomb number', 
        cn: '请选择雷号',
    },
};




